import { schema } from "normalizr";

const LeaveRequestSchema = new schema.Entity("leaveRequests");
const LeaveRequestArraySchema = new schema.Array(LeaveRequestSchema);

export { LeaveRequestSchema, LeaveRequestArraySchema };